<template>
  <v-container class="pa-3" fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Invoice Report</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6">
          <!-- <xlsx-workbook @change="onChange" @created="onCreated">
            <xlsx-sheet
              :collection="sheet.data"
              v-for="sheet in sheets"
              :key="sheet.name"
              :sheet-name="sheet.name"
            />
            <xlsx-download :filename="exportleavereport">
              <v-btn outlined rounded class="btnexport">
                <span>Export</span>
                <v-icon small center>mdi-download</v-icon>
              </v-btn>
            </xlsx-download>
          </xlsx-workbook> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.company_inv = '';
            })
            " v-model="datasearch.company_inv" :items="company_list" label="Company" item-text="name"
            item-value="value" outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" v-if="disabled_dep">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.department = 0;
            })
            " v-model="datasearch.department" :items="department_list" label="Department" item-text="department_name"
            item-value="id" outlined dense :disabled="disabled_dep" background-color="#F5F5F5"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" v-if="!disabled_dep">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.department = 0;
            })
            " v-model="datasearch.department" :items="department_list" label="Department" item-text="department_name"
            item-value="id" outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.customer_id = 0;
            })
            " v-model="datasearch.customer_id" :items="customer_list" label="Client" item-text="name" item-value="id"
            outlined dense></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="2">
          <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                dense outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly dense
                outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.status = 0;
            })
            " v-model="datasearch.status" :items="status_list" label="Status" item-text="name" item-value="status_no"
            outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-btn @click="onSearchPagination" class="mr-4">
            <v-icon left>mdi-magnify</v-icon> Search</v-btn>
          <v-btn class="mr-4" color="light-blue lighten-3" @click="opendata" v-if="mDataArray2.length > 0">
            <v-icon left>mdi-printer</v-icon>
            Print
          </v-btn>
        </v-col>
      </v-row>

      <v-card outlined tile>
        <!-- <v-data-table
          dense
          :search="search"
          :headers="headers"
          :items="mDataArray"
          class="elevation-1   595959"
        >
        </v-data-table> -->

        <!-- Pagination Section -->
        <div>
          <v-select v-model="itemsPerPage" @change="onItemsPerPageChange" style="width: 150px"
            :items="item_per_page_list" label="Items per page" dense outlined hide-details></v-select>
        </div>
        <div>
          <div class="text-center pt-2">
            <v-pagination class="ma-3" v-model="page" :length="pageCount" @input="loadDataByPage"
              total-visible="19"></v-pagination>
          </div>

          <v-data-table :headers="headers" :items="mDataArray2" :server-items-length="totalItems"
            :options.sync="options" @update:options="onOptionsUpdate" hide-default-footer class="elevation-1"
            :loading="tableLoading" loading-text="Loading... Please wait">
            <!-- Custom loading slot สำหรับแสดง loading แบบวงกลม -->
            <template v-slot:progress>
              <div class="text-center pa-6">
                <v-progress-circular indeterminate color="primary" size="50" width="8"></v-progress-circular>
                <div class="mt-3 text-subtitle-1 primary--text">
                  กำลังโหลดข้อมูล...
                </div>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-card>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="pb-4"></div>

      <template>
        <div id="mydivhtmltobase">
          <div v-for="index in datashowAll.length" v-if="datashowAll.length >= 0 || pageAll >= 0">
            <div class="aligncenter" id="foo">
              <page size="A4" class="aligncenter">
                <br />
                <div class="aligncenter">
                  <div class="rowprpo">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright colprpo mr30prpo mt10 mb-5">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div class="rowprpo aligncenter mb-5">
                    <div class="col-md-12report mt-30prpo">
                      <h2>
                        {{ dataformatpr.title }}
                      </h2>
                    </div>
                  </div>
                  <div class="rowprpo aligncenter">
                    <div class="col-md-12report">
                      <h3>
                        {{ dataformatpr.subtitle }}
                      </h3>
                    </div>
                  </div>
                  <div class="rowprpo aligncenter">
                    <div class="col-md-12report">
                      <h5>
                        Date From {{ dataformatpr.datefrom }} T0
                        {{ dataformatpr.dateto }}
                      </h5>
                    </div>
                  </div>
                </div>
                <br />
                <div class="rowprpo caption ml30prpo mr30prpo mb-2" style="margin-top: 10px">
                  <table class="captionhtable">
                    <tr>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width25">
                        <span class="alignleft">Department </span>
                      </th>

                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width20">
                        <span class="aligncenter">Date </span>
                      </th>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width30">
                        <span class="alignleft">Client Name</span>
                      </th>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width20">
                        <span class="alignleft">Invoice No.</span>
                      </th>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width15">
                        <span class="alignright">Amount</span>
                      </th>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width18">
                        <span class="aligncenter">Currency</span>
                      </th>
                      <th scope="colgroup" class="prborderbottom2pxhtable prbordertop2pxhtable width18">
                        <span class="aligncenter">Status</span>
                      </th>
                    </tr>
                  </table>
                </div>
                <div v-for="(data, i) in datashowAll[index - 1]" id="content" class="rowprpo caption ml30prpo mr30prpo">
                  <table class="">
                    <tr valign="top">
                      <th class="width25">
                        <span class="alignleft" v-if="data.department_name_show">
                          {{
                            data.department_name_show.length > 16
                              ? data.department_name_show.slice(0, 16) + "..."
                              : data.department_name_show
                          }}
                        </span>
                        <span class="alignleft" v-else>-</span>
                      </th>

                      <th class="width20">
                        <span class="aligncenter" v-if="data.inv_date_show">{{
                          data.inv_date_show
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                      <th class="width30 textalignleft">
                        <span class="textalignleft" v-if="data.cus_name">
                          {{
                            data.cus_name.length > 16
                              ? data.cus_name.slice(0, 16) + "..."
                              : data.cus_name
                          }}
                        </span>
                        <span class="textalignleft" v-else>-</span>
                      </th>
                      <th class="width20">
                        <span class="alignleft" v-if="data.inv_id_show">{{
                          data.inv_id_show
                        }}</span>
                        <span class="alignleft" v-else>-</span>
                      </th>
                      <th class="width15">
                        <span class="alignright" v-if="data.amount_total_show">{{ data.amount_total_show }}</span>
                        <span class="alignright" v-else>-</span>
                      </th>
                      <th class="width18">
                        <span class="aligncenter" v-if="data.currency">{{
                          data.currency
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                      <th class="width18">
                        <span class="aligncenter" v-if="data.statusshow">{{
                          data.statusshow
                        }}</span>
                        <span class="aligncenter" v-else>-</span>
                      </th>
                    </tr>
                  </table>
                </div>
              </page>
            </div>
          </div>
        </div>
      </template>

      <v-card-actions class="mt-5">
        <v-spacer></v-spacer>

        <v-btn v-if="this.datashowAll.length > 0" depressed outlined buttonred width="100" @click="exportToPDF">
          print
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>
      <v-row justify="center">
        <v-dialog v-model="dialogSelectTitle" scrollable max-width="35%">
          <v-card class="pa-4">
            <v-card-text>
              <div class="d-flex align-center mb-0 mt-5">
                <span class="text-h5 font-weight-bold">Select Company</span>
              </div>

              <v-radio-group v-model="dialogSelectClientInfo" column>
                <v-radio label="DEJ-UDOM & ASSOCIATES LIMITED" value="1" class="mb-2"></v-radio>
                <v-radio label="สำนักงานทนายความ" value="3" class="mb-2"></v-radio>
              </v-radio-group>
            </v-card-text>

            <v-card-actions style="margin-top: -30px;">
              <v-row no-gutters>
                <v-col cols="6" class="pr-2">
                  <v-btn color="#106a94" large rounded dark elevation="0" @click="exportToPDF" block>
                    Print Preview
                  </v-btn>
                </v-col>
                <v-col cols="6" class="pl-2">
                  <v-btn color="#fc1526" large rounded dark elevation="0" @click="dialogSelectTitle = false" block>
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />

      </v-row>
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import invoiceReport from "@/utils/pdfInvoiceReport";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    await this.loadDepartmentByCompanyId();
    await this.loadCustomer();

    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    PdfPreviewDialog,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      pdfBlob: null,
      pdfObj: null,
      dialogPDF: false,
      dialogSelectClientInfo: "1",
      dialogSelectTitle: false,
      userrole: "user",
      tableLoading: false,
      hasSearched: false,
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      company_list: [
        { value: "D", name: "บริษัท เดชอุดม จำกัด" },
        { value: "L", name: "สำนักกฎหมาย เดชอุดม" },
      ],
      showsearchsum: false,
      employeeisdisable: false,
      exportleavereport: "leave_report.xlsx",
      sheets: [
        {
          name: "InvioceReport",
          data: [],
        },
      ],
      search: "",
      headers: [
        {
          text: "Company",
          value: "company_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Department",
          value: "department",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Date",
          value: "inv_date_show",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
        {
          text: "Client Name",
          value: "cus_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Invoice No.",
          value: "inv_id_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "statusshow",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "amount_total_show",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },
      ],
      mDataArray: [],
      dataAll: [],
      sum_show_table: [],
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",

      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      status_list: [
        {
          name: "Draft",
          status_no: 1,
        },
        {
          name: "P.invoice",
          status_no: 2,
        },
        {
          name: "Invoice",
          status_no: 3,
        },
        {
          name: "Void",
          status_no: 4,
        },
        // {
        //   name: "Credit Note",
        //   status_no: 5,
        // },
        // {
        //   name: "Receive",
        //   status_no: 6,
        // },
      ],
      dataformatpr: {
        title: "",
        subtitle: "Invoice Report",
        dateto: "",
        datefrom: "",
      },
      disabled_dep: false,
    };
  },
  methods: {
    // เปลี่ยนจำนวนแถว: ค้นหาใหม่เฉพาะเมื่อเคยกด Search แล้ว
    onItemsPerPageChange() {
      if (this.hasSearched) this.onSearchPagination();
    },
    // จัดรูปแบบข้อมูลแต่ละแถว (เหมือนตอนแสดงในตาราง)
    mapReportRow(item) {
      if (item.inv_id != "") {
        item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""}`;
      } else if (item.pinv_id != "") {
        item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""}`;
      } else {
        item.inv_id_show = "####";
      }
      item.amount_total_show = tolocalestringnumber(
        item.amount_total_after_cal ? item.amount_total_after_cal : 0
      );
      return item;
    },

    // ดึงข้อมูลทุกหน้าสำหรับ print
    async fetchAllForPrint() {
      const total = Number(this.totalItems) || 0;
      if (total === 0) return [];

      if (localStorage.getItem("dtime_role") == "ADMIN" && this.datasearch.department == 0) {
        this.userrole = "admin";
      } else {
        this.userrole = "user";
      }

      const res = await api.billing_expense_getdataReportInv_Pagination(
        this.userrole,
        1,
        total, // ดึงทั้งหมดในหน้าเดียว
        "ih.inv_id",
        "ASC",
        localStorage.getItem(server.COMPANYID),
        this.datasearch.datefrom,
        this.datasearch.dateto,
        this.datasearch.customer_id,
        this.datasearch.company_inv,
        this.datasearch.department,
        this.datasearch.status
      );

      const rows = (res.data && res.data.data) || [];
      return rows.map((item) => this.mapReportRow(item));
    },
    getFileName() {
      const com = this.company_list.find((x) => x.value === this.datasearch.company_inv);
      const dep = this.department_list.find((x) => x.id === this.datasearch.department);
      const cus = this.customer_list.find((x) => x.id === this.datasearch.customer_id);

      const clean = (s) => (s || "").replace(/[\\/:*?"<>|]/g, "-").trim();

      const parts = [
        "Invoice_Report",
        clean(com && com.name),
        clean(dep && dep.department_name),
        clean(cus && cus.name),
        this.datasearch.datefrom,
        this.datasearch.dateto,
      ].filter(Boolean);

      return parts.join("_") + ".pdf";
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   1,
        //   this.itemsPerPage,
        //   "id",
        //   "ASC",
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        this.$showLoader();
        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          1,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                  }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      if (!this.hasSearched) return;
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   options.page,
        //   this.itemsPerPage,
        //   options.sortBy[0],
        //   sortDesc,
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        //log param
        console.log(`param options:`, JSON.stringify(options));

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );

        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                  }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          // this.$store.state.global_dialog = true;
          // this.setupAlertDialog(
          //   true,
          //   "ค้นหาข้อมูล",
          //   "ไม่มีข้อมูล",
          //   "text-h5 red--text text-center"
          // );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   pageNumber,
        //   this.itemsPerPage,
        //   "id",
        //   "ASC",
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          pageNumber,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                  }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.hasSearched = true;
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "id",
        sortOrder: "ASC",
        company_id: localStorage.getItem(server.COMPANYID),
        department_id: localStorage.getItem(server.DEPARTMENT_ID),
      };

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   s_data.page,
        //   s_data.limit,
        //   s_data.sortBy,
        //   s_data.sortOrder,
        //   s_data.company_id,
        //   s_data.department_id,
        //   s_data.search
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          1,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.company_inv == "D") {
              item.company_name = "DEJUDOM & ASSOCIATES LTD.";
            } else {
              item.company_name = "สำนักงานกฎหมาย เดชอุดม";
            }

            //    if (code === "D") return "DEJUDOM & ASSOCIATES LTD.";
            // if (code === "L") return "สำนักงานกฎหมาย เดชอุดม";

            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                  }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    onCreated(wb) { },
    onChange(wb) {
      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];
      wb.Sheets.leavereport.A1 = {
        t: "s",
        v: `Export invoice Repot as of   ${this.dateCurrent}`,
      };
      wb.Sheets.leavereport.B1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.C1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.D1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.E1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.F1 = { t: "s", v: "" };
      wb.Sheets.leavereport.G1 = { t: "s", v: "" };
      wb.Sheets.leavereport.H1 = { t: "s", v: "" };
      wb.Sheets.leavereport.I1 = { t: "s", v: "" };
      wb.Sheets.leavereport.J1 = { t: "s", v: "" };
      wb.Sheets.leavereport.K1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.L1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.M1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.N1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.O1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.P1 = { t: "s", v: "" };

      wb.Sheets.leavereport.A3 = { t: "s", v: "Employee" };
      wb.Sheets.leavereport.B3 = { t: "s", v: "Leave Type" };
      wb.Sheets.leavereport.C3 = { t: "s", v: "date time from" };
      wb.Sheets.leavereport.D3 = { t: "s", v: "date time to" };
      wb.Sheets.leavereport.E3 = { t: "s", v: "" };
      wb.Sheets.leavereport.F3 = { t: "s", v: "Description" };
      // wb.Sheets.leavereport.I3 = { t: "s", v: "report" };
      // wb.Sheets.leavereport.J3 = { t: "s", v: "payment Request" };
      // wb.Sheets.leavereport.K3 = { t: "s", v: "Cert" };
      // wb.Sheets.leavereport.L3 = { t: "s", v: "Done" };
      // wb.Sheets.leavereport.M3 = { t: "s", v: "Next90" };
      // wb.Sheets.leavereport.N3 = { t: "s", v: "Next60" };

      wb.Sheets.leavereport["!merges"] = merge;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.billing_expense_getAllDepartment_By_CompanyID(
        this.mycompany_id,
      );
      this.department_list = result.data;

      const res_user = await api.getAccountid(
        Number(localStorage.getItem(server.USER_ID)),
      );

      if (
        Number(res_user.data[0].department_i_d) != 6 &&
        Number(localStorage.getItem(server.USER_ID)) != 1
      ) {
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          this.disabled_dep = false;
        } else {
          this.disabled_dep = true;
        }

        this.datasearch.department = res_user.data[0].department_i_d;
      } else {
        this.disabled_dep = false;
        this.datasearch.department = res_user.data[0].department_i_d;
      }
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_list = result.data;
    },

    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {
        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },

    async SearchAlldata() {
      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.dataAll = [];
      this.mDataArray = [];
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      this.$showLoader();
      let resultsearch = await api.getdataReportInv({
        params: this.datasearch,
      });
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID),
      );

      if (resultsearch.data.length > 0) {
        let data_set = resultsearch.data;
        data_set.forEach((item, index) => {
          if (item.inv_id != "") {
            item.inv_id_show = `${item.inv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
          } else {
            if (item.pinv_id != "") {
              item.inv_id_show = `${item.pinv_id} ${item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
            } else {
              item.inv_id_show = "####";
            }
          }
          item.amount_total_show = tolocalestringnumber(
            item.amount_total_after_cal ? item.amount_total_after_cal : 0,
          );
          this.dataAll[index] = item;
        });
        this.mDataArray = this.dataAll;
        // show pdf

        // await this.setexporttoxlsx();
        if (localStorage.getItem(server.COMPANYID) == 1) {
          if (this.datasearch.company_inv == "L") {
            this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }
        } else {
          this.dataformatpr.title = copany_datat.data[0].name;
        }

        this.dataformatpr.datefrom = unity.formatDate(this.datasearch.datefrom);
        this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

        this.dataforshowprpo = resultsearch.data;
        // await this.checkcontent();
        this.$hideLoader();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center",
        );
        return;
      }
    },

    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    async checkcontent() {
      let totalclient = 0;
      this.setdatatoshow = [];
      let linedetailprpo = 40;
      let datainlineprpo = 27;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;

      for (let i = 0; i < this.dataforshowprpo.length; i++) {
        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก

        newhllinedetails = 0;
        getnewdata = [];

        this.dataforshowprpo[i].no = i + 1;

        let stringchecklength = "";

        if (this.dataforshowprpo[i].cus_name != null) {
          let lengthofdataforshowprpo = this.dataforshowprpo[i].cus_name.length;
          stringchecklength = this.dataforshowprpo[i].cus_name;

          for (let j = 0; j < this.dataforshowprpo[i].cus_name.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo,
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        } else {
          if (this.dataforshowprpo[i].department == null) {
            this.dataforshowprpo[i].department = "-";
          }
          let lengthofdataforshowprpo = this.dataforshowprpo[i].department
            .length;
          stringchecklength = this.dataforshowprpo[i].department;

          for (let j = 0; j < this.dataforshowprpo[i].department.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo,
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        }
      }

      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;

      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
    },
    buildInvoiceContent(data = this.mDataArray2 || []) {

      // 🔥 sort: department → date
      const sorted = [...data].sort((a, b) => {
        const deptA = a.department || "Other Departments";
        const deptB = b.department || "Other Departments";

        // 🔥 ดัน Other Departments ไปท้ายสุด
        if (deptA === "Other Departments" && deptB !== "Other Departments")
          return 1;
        if (deptA !== "Other Departments" && deptB === "Other Departments")
          return -1;

        // ปกติ sort ตามชื่อ department
        if (deptA !== deptB) {
          return deptA.localeCompare(deptB);
        }

        // แล้วค่อย sort date
        return new Date(a.inv_date_pdf) - new Date(b.inv_date_pdf);
      });

      const departmentMap = new Map();

      sorted.forEach((row) => {
        const deptKey = row.department || "Other Departments";
        const dateKey = row.inv_date_pdf;

        // ===== DEPARTMENT =====
        if (!departmentMap.has(deptKey)) {
          departmentMap.set(deptKey, {
            department_name: deptKey,
            dates: new Map(),
          });
        }

        const department = departmentMap.get(deptKey);

        // ===== DATE =====
        if (!department.dates.has(dateKey)) {
          department.dates.set(dateKey, {
            date: dateKey,
            items: [],
          });
        }

        const dateGroup = department.dates.get(dateKey);

        // ===== ITEM =====
        dateGroup.items.push({
          client_name: row.cus_name || "",
          invoice_no: row.inv_id_show ? row.inv_id_show : "####",
          amount: Number(
            String(row.amount_total_after_cal || 0).replace(/,/g, ""),
          ),
          currency: row.currency || "",
          status: row.statusshow || "",
          status_code: row.status, // ใช้นับ Valid / Voided ใน summary
        });
      });

      // 🔥 convert Map → Array
      return Array.from(departmentMap.values()).map((dept) => ({
        department_name: dept.department_name,
        dates: Array.from(dept.dates.values()),
      }));
    },
    async opendata() {
      if (
        Number(localStorage.getItem(server.COMPANYID)) != 1 &&
        Number(localStorage.getItem(server.COMPANYID)) != 3
      ) {
        await this.exportToPDF();
      } else {
        this.dialogSelectTitle = true;
      }
    },
    async exportToPDF() {
      this.dialogSelectTitle = false;
      this.$showLoader();

      try {
        // ดึงข้อมูลครบทุกหน้า
        const allRows = await this.fetchAllForPrint();
        if (allRows.length === 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Print",
            "ไม่มีข้อมูลสำหรับพิมพ์",
            "text-h5 red--text text-center"
          );
          return;
        }

        var res_company = [];
        if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
          res_company = await api.getCompanyByID(
            localStorage.getItem(server.COMPANYID)
          );
        } else {
          res_company = await api.getCompanyByID(
            Number(this.dialogSelectClientInfo)
          );
        }

        const pdfheader = {
          company_name_en: res_company.data[0].name || "",
          company_name_th: res_company.data[0].inv_company_name_th || "",
          date_from: this.datasearch.datefrom,
          date_to: this.datasearch.dateto,
        };

        const content = this.buildInvoiceContent(allRows);

        const blob = await invoiceReport.exportToPDF({
          header: pdfheader,
          content: content,
        });
        this.pdfBlob = blob;
        this.dialogPDF = true;
      } catch (error) {
        console.error("exportToPDF error:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      } finally {
        this.$hideLoader();
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
  text-align: left;
}

.alignright {
  float: right;
  text-align: right;
}

.aligncenter {
  text-align: center;
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignleftcus {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 2px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 2px solid black;
}

td {
  /* border: 1px solid black; */
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width18 {
  word-wrap: break-word;
  width: 18%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width25 {
  word-wrap: break-word;
  width: 22%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width45 {
  word-wrap: break-word;
  width: 45%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
                body.A3.landscape { width: 420mm }
                body.A3, body.A4.landscape { width: 297mm }
                body.A4, body.A5.landscape { width: 210mm }
                body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}

.v-btn:not(.v-btn--round).v-size--default.btnimport {
  background-color: #ffffff;
  color: #25b360;
}

.v-btn:not(.v-btn--round).v-size--default.btnexport {
  background-color: #ffffff;
  color: #33a4c0;
}
</style>